import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile-ranking',
  templateUrl: './profile-ranking.component.html',
  styleUrls: ['./profile-ranking.component.scss']
})
export class ProfileRankingComponent implements OnInit {
  lastTableLazyLoadEvent: LazyLoadEvent;
  items: Object;
  userLatestScore: any;
  userLatestRank: any;
  scoreList: any;
  totalRecords: any;
  loggedInUser: any;
  isLoggedIn: boolean;
  userId: any;
  public paginationOption = environment.pagination;
  public loading: boolean = false;
  tournamentCategory: any = [];
  catList: any = [];
  ageList: any[];
  selectedCatId: any;
  tournamentResult: any[];
  selectedAgeGroupId: any;
  filtervisible: boolean = false;

  constructor(private tournamentsService: TournamentsService, private tokenStorage: TokenStorageService, private tournamentService: TournamentsService) { }

  ngOnInit(): void {
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    this.getTournamentCategories();
  }

  getTournamentCategories() {
    this.tournamentService.gettournamentLeaderCategory().subscribe((data) => {
      this.tournamentCategory = data['items'];
      var catlist = data['items'];
      catlist.forEach((element) => {
        let obj = {
          label: element.matchName[0].name,
          value: element.matchName[0]._id,
          slug: element.matchName[0].slug,
          sequence: element.matchName[0].sequence,
        };
        this.catList.push(obj);
      });
      this.catList.sort((a, b) => a.sequence - b.sequence);
    });
  }

  onselectGetCategory(event) {
    this.ageList = [];
    if (event.value != null) {
      this.selectedCatId = event.value.value;
      let index = this.findIndexById(this.selectedCatId, this.tournamentCategory);
      let agegrouplist = this.tournamentCategory[index];
      agegrouplist['ageGroupData'].sort((a, b) => a.sequence - b.sequence);
      this.ageList = [];
      agegrouplist['ageGroupData'].forEach((element) => {
        let obj = {
          label: element.name,
          value: element._id,
          slug: element.slug,
        };
        this.ageList.push(obj);
      });
    } else {
      this.ageList = [];
      this.selectedCatId = null;

    }
    this.tournamentResult = [];
  }

  onAgeGroupSelect(event) {
    if (event.value != null) {
      this.selectedAgeGroupId = event.value.value;
    } else {
      this.selectedAgeGroupId = null
    }
    this.getUserScore(this.lastTableLazyLoadEvent);
  }

  findIndexById(id, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      if (array[i]['_id']['matchTypeId'] === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  filterDialog() {
    this.filtervisible = true;
  }

  getUserScore(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;

    let query = "filterByDisable=false&filterByPublishStatus=true";
    let pagenumber = 1;
    let params = "";
    let rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.selectedCatId && this.selectedAgeGroupId) {
      query += "&filterByMatchId=" + this.selectedCatId + "&filterByAgegroupId=" + this.selectedAgeGroupId;
    }

    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    this.tournamentsService.tournamentRankingHistoryPlayerscore(this.userId, query).subscribe((res) => {
      this.items = res;
      this.userLatestScore = res['totalRank'];
      this.scoreList = res['items'];
      this.totalRecords = res["totalCount"];
      this.userLatestRank = res['items']?.[0]?.['playerRating'];
    });
  }

}
